import {
  OrderSummaryInfoRow,
  OrderSummaryInfoRowProps,
} from '@euler/app/components/order/summary/SummaryInfoRow';
import { shouldDisplayField } from '@euler/app/components/order/summary/util';
import { Typography } from '@euler/app/components/typography';
import { maskedMobilePhone } from '@euler/app/tv/functions/maskedMobilePhone';
import { Center } from '@euler/components/Center';
import { Icon } from '@euler/components/Icomoon';
import { HStack } from '@euler/components/layout/Stack';
import { kOrderFieldNoValuePlaceHolder } from '@euler/functions/order/constants';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Maybe } from '@euler/types';
import { onErrorAlert } from '@euler/utils';
import { isMobilePhone } from '@euler/utils/validators';
import { memo, useCallback } from 'react';
import { Linking, Platform } from 'react-native';
import { useTheme } from 'styled-components';

export const CustomerPhoneInfoRow = memo(
  ({
    value,
    visibility,
    defaultVisible,
    canDialCustomer,
    contentStyle,
    labelStyle,
    textStyle,
    ...props
  }: Omit<
    OrderSummaryInfoRowProps<Maybe<string>>,
    'label' | 'copyable' | 'note' | 'format' | 'valid' | 'children'
  > & {
    canDialCustomer?: boolean;
  }) => {
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    const isVisible = shouldDisplayField({
      value,
      visibility,
      defaultVisible,
    });

    const onDialCustomer = useCallback(() => {
      if (!value || !isMobilePhone(value) || !canDialCustomer) {
        return;
      }
      Linking.openURL(`tel:${value}`).catch(onErrorAlert);
    }, [canDialCustomer, value]);

    if (!isVisible) {
      return null;
    }

    return (
      <HStack
        justifyContent="flex-start"
        alignItems="center"
        mb={rpx(6.5)}
        {...props}
      >
        <OrderSummaryInfoRow
          label="客户手机"
          value={value}
          mb={0}
          copyable={canDialCustomer ? value : false}
          contentStyle={contentStyle}
          labelStyle={labelStyle}
          textStyle={textStyle}
          fallbackText={kOrderFieldNoValuePlaceHolder}
          format={x => (!canDialCustomer ? maskedMobilePhone(x) : x)}
        />
        {Platform.OS !== 'web' &&
          value &&
          isMobilePhone(value) &&
          canDialCustomer && (
            <Center.Touchable
              ml={rpx(8)}
              flexDirection="row"
              onPress={onDialCustomer}
            >
              <Icon name="phone-hang-up" color={theme.link} size={rpx(16)} />
              <Typography.Label
                light
                size={rpx(12)}
                color={theme.link}
                ml={rpx(5)}
              >
                拨打
              </Typography.Label>
            </Center.Touchable>
          )}
      </HStack>
    );
  },
);
